module.exports = __webpack_public_path__ + "img/grip.6e9e4ebb.svg";